import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconRepeatOn$1 = /*@__PURE__*/ proxyCustomElement(class WppIconRepeatOn extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-repeat-on", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M15.75 6.01C15.9293 6.01 16.0939 6.07292 16.2229 6.17788C17.3108 7.09184 18.0024 8.46516 18.0024 10C18.0024 12.6888 15.8801 14.8818 13.2193 14.9954L13.0024 15H8.56056L9.78031 16.2197C10.0466 16.4859 10.0708 16.9026 9.85293 17.1962L9.78031 17.2803C9.51404 17.5466 9.09738 17.5708 8.80377 17.3529L8.71965 17.2803L6.21965 14.7803C5.95338 14.5141 5.92917 14.0974 6.14703 13.8038L6.21965 13.7197L8.71965 11.2197C9.01254 10.9268 9.48741 10.9268 9.78031 11.2197C10.0466 11.4859 10.0708 11.9026 9.85293 12.1962L9.78031 12.2803L8.56056 13.5H13.0024C14.871 13.5 16.3975 12.0357 16.4972 10.192L16.5024 10C16.5024 8.91885 16.0122 7.95219 15.2419 7.31017C15.0935 7.17538 15 6.97861 15 6.76C15 6.34579 15.3358 6.01 15.75 6.01ZM10.2196 2.71967C10.4859 2.4534 10.9026 2.4292 11.1962 2.64705L11.2803 2.71967L13.7803 5.21967L13.8529 5.30379C14.0466 5.56478 14.049 5.92299 13.8601 6.18638L13.7803 6.28033L11.2803 8.78033L11.1962 8.85295C10.9352 9.0466 10.577 9.04899 10.3136 8.86012L10.2196 8.78033L10.147 8.69621C9.95338 8.43522 9.95099 8.07701 10.1399 7.81362L10.2196 7.71967L11.4386 6.5H6.99756C5.129 6.5 3.60243 7.96428 3.50274 9.80796L3.49756 10C3.49756 11.0831 3.98957 12.0514 4.76229 12.6934C4.90848 12.8289 4.99998 13.0238 4.99998 13.24C4.99998 13.6542 4.66419 13.99 4.24998 13.99C4.05869 13.99 3.88413 13.9184 3.75164 13.8005C2.67864 12.8872 1.99756 11.5232 1.99756 10C1.99756 7.31124 4.11987 5.11818 6.78067 5.00462L6.99756 5H11.4386L10.2196 3.78033L10.147 3.69621C9.92918 3.4026 9.95338 2.98594 10.2196 2.71967Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-repeat-on-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-repeat-on", "wpp-icon-repeat-on-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-repeat-on-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-repeat-on-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconRepeatOn$1);
      }
      break;
  } });
}

const WppIconRepeatOn = WppIconRepeatOn$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconRepeatOn, defineCustomElement };
